import { styled, css } from "../../../../../../../styles";

// Components

export const ModalContentContainer = styled("div", {
  height: "100%",
  width: "100%",
  overflowY: "overlay",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "rgba(248, 248, 248, 0.8)",
  padding: "5px",

  "&::-webkit-scrollbar": {
    width: "$4",
  },

  "&:hover": {
    "&::-webkit-scrollbar": {
      width: "$4",
      backgroundColor: "transparent",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "$gray-50",
      borderRadius: "10px",
    },
  },
});

export const QuestionDetailsContainer = styled("div", {
  width: "100%",

  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",

  rowGap: "10px",

  padding: "20px",
  pointerEvents: "auto",

  ".ant-select": {
    height: "42px !important",
  },

  p: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",

    color: "$charcoal",

    fontSize: "15px",
    lineHeight: "16px",
    fontFamily: "$openSans",
  },
});

export const QuestionDetailsContainerRow = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",

  columnGap: "20px",
  height: "42px",
  width: "450px",

  variants: {
    spaceRight: {
      true: {
        width: "210px",
      },
    },
  },
});

export const ToggleStyleClass = css({
  "&:hover": {
    cursor: "pointer",
  },
  marginRight: "10px",
});

export const ConditionalJumpToggleContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const HandleQuestionFormContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "30px 0 0px 16px",
});

export const SectionContainer = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  padding: "10px 0 0 10px",

  p: {
    marginRight: "10px",
  },
});

// CSS

export const textInputCss = css({
  width: "60px",

  span: {
    margin: "0px",
  },

  p: {
    width: "100% !important",
  },

  input: {
    border: "2px solid $gray-50",
    borderRadius: "6px",
    paddingLeft: "11px",
    paddingRight: "11px",
  },
});
